<sl-titulo>{{ unloggedLayoutTitle | easyplaceholder: "Completa tus datos" }}</sl-titulo>

<ndc-dynamic 
    [ndcDynamicComponent]="component"
    [ndcDynamicInputs]="inputs"
    [ndcDynamicOutputs]="outputs"
></ndc-dynamic>